import { render, staticRenderFns } from "./PrivilegeClassify.vue?vue&type=template&id=5270ee2e&scoped=true&"
import script from "./PrivilegeClassify.vue?vue&type=script&lang=js&"
export * from "./PrivilegeClassify.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeClassify.vue?vue&type=style&index=0&id=5270ee2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270ee2e",
  null
  
)

export default component.exports